import Icon from 'semantic-ui-react/dist/es/elements/Icon';
import './Icon.css';

export default Icon;
